/*
    Page shell for displaying the list of records for the
    Reassignment Report

    Holds the filter for that data,
    and has the option for exporting the report to Excel

    uses AutoSizer + FixedSizeList in order to avoid
    rendering an enormous list of data records up front,
    and instead only do so for the particular records on screen at once
*/

import React, { useContext } from "react";

import MainContext from "../MainContext";
import DataContext from "../DataContext";

import VerticalLayout from "../Components/VerticalLayout";
import SubNav from "../Components/SubNav";

import ReportReassignmentFilter from "../Filters/ReportReassignmentFilter";
import ReportReassignmentData from "../DataDisplay/ReportReassignmentData";

import ReportExport from "../Components/Excel/ReportExport";

import { getReassignmentReport, getReassignmentReportPDF } from "../Requests/ReportRequests";

// total height of 76px (including 12px bottom margin) seems to work
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

//
// a construction for making sure that the page responds
// immediately for requests to reload the data,
// as communicated via the wrapping DataContext
//
const ReportReassignmentPageContainer = (props) => {
    const context = useContext(DataContext);

    return (
        <ReportReassignmentPage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default ReportReassignmentPageContainer;

class ReportReassignmentPage extends React.Component {

    static contextType = MainContext;

    state = {
        filterValues: null,
        data: [],
        message : ""
    }

    applyFilter = (values, callback) => {
        this.context.toggleFilter();
        this.setState({filterValues: values, message: ""}, () => {
            this.getData(callback);
        });

    }

    getData = (callback) => {
        const request = () => getReassignmentReport(this.state.filterValues);

        const then = ({data}) => {

            console.log("we got data back", data);

            const message = (data.length > 0) ? "" : "No Records Found for this Filter";

            this.setState({data, message}, () => {
                if(callback && typeof callback === "function"){
                    callback();
                }
            });
        };

        this.context.runProcessing(request, then, "getReassignmentReport");
    }

    runPDF = () => {
        const request = () => getReassignmentReportPDF(this.state.filterValues);
        const then = (res => {
            ;
        });
        this.context.runProcessing(request, then, "getStarterSheetPDF");
    }

    // this is a necessary method for using the 
    // AutoSizer + FixedSizeList components
    NextRow = ({ index, style }) => (
        <div style={style}>
            <ReportReassignmentData key={index} data={this.state.data[index]} />
        </div>
    )

    componentDidUpdate() {
        if(this.props.dataReload){
            console.log("GET DATA!!!");
            this.props.setReload(false, () => {                
                this.getData();
            });
        }
    }

    render() {

        const firstHeight = (this.state.data.length === 0 || this.context.filterOpen) ? 0 : 8;

        return (
            <VerticalLayout firstHeight={firstHeight}>
                {
                    // the excel export
                    !this.context.filterOpen && this.state.data.length > 0
                    ?<div>
                        <SubNav>
                            <ReportExport filename="XXX" data={[]} filter={null} />
                            <div className="option  " onClick={this.runPDF}>PDF</div>
                        </SubNav>
                    </div>
                    : null
                }
                <div className="content-nooverflow">
                    <>
                    {
                        // the filter
                        this.context.hasFilter
                        && this.context.filterOpen
                            ? <ReportReassignmentFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                            : null
                    }
                    {
                        // the data itself
                        this.state.data.length > 0
                        ? <AutoSizer>
                        {
                            ({height, width}) => (
                                <FixedSizeList
                                className="fixed-list"
                                height={height}
                                width={width}
                                itemCount={this.state.data.length}
                                itemSize={76}
                                >
                                {this.NextRow}
                                </FixedSizeList>
                            )
                        }
                        </AutoSizer>    
                        : null
                    }
                    {
                        this.state.message
                        ? <div className="message">
                            {this.state.message}
                        </div>
                        : null
                    }
                    </>
                </div>
            </VerticalLayout>
        );
    }
}
